<template>
  <div
    style="font-size: smaller"
    class="ma-2"
  >
    <div>
      <v-icon v-if="expanded">mdi-triangle-small-down</v-icon>
      <v-icon
        v-else
        class="mdi-rotate-270"
      >
        mdi-triangle-small-down
      </v-icon>
      <a
        href="javascript:void(0)"
        @click="expanded = !expanded"
      >
        {{ reference?.SourceName }}
      </a>
    </div>
    <div
      v-if="expanded"
      class="container border pa-5"
    >
      <template v-for="(key, i) in fields">
        <div
          v-if="headers[key]"
          :key="i"
          class="row"
        >
          <div class="col-2 pa-0">{{ headers[key] }}</div>
          <div class="col pa-0">
            <a
              v-if="key === 'URL'"
              :href="reference[key]"
              target="_blank"
            >
              {{ reference[key] }}
            </a>
            <span v-else>{{ reference[key] }}</span>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReferenceInfo',
  props: {
    reference: {
      type: Object,
      mandatory: true,
    },
  },

  data: () => ({
    expanded: false,
    fields: ['SourceName', 'Name', 'URL', 'Description'],
    headers: {
      ANID: null,
      Description: 'Description',
      LicenseNote: null,
      LicenseURL: null,
      Name: 'Record Name',
      ReferenceNumber: null,
      SourceID: null,
      SourceName: 'Source',
      URL: 'URL',
    },
  }),
}
</script>
